import React from 'react'
import { eqxAppConfigApi } from '../../shared/interfaces/eqxAppConfig'
import { isStaging, useTenantlessDeploymentContext } from './AppTenantlessDeploymentProvider'

interface AppBaseConfig {
    name: string
    version: string
    api: eqxAppConfigApi
}
interface AppBaseConfigGetter {
    getConfig: (environment: string, instance?: string) => AppBaseConfig
}
const AppBaseConfigContext = React.createContext<AppBaseConfigGetter | undefined>(undefined)

export const AppBaseConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let url = process.env.REACT_APP_API_URL
    if (!url) {
        throw new Error('API URL is not set')
    }

    const config: AppBaseConfig = {
        name: 'Continuum Go',
        version: '2026.40.0',
        api: {
            baseUrl: url,
        },
    }
    const getConfig = (environment: string, instance?: string) => {
        let envConfig = config;
        if (isStaging() && process.env.REACT_APP_API_URL_STAGING) {
            envConfig.api.baseUrl = process.env.REACT_APP_API_URL_STAGING
        }
        return envConfig;
    }

    return (
        <AppBaseConfigContext.Provider value={{ getConfig }}>
            {children}
        </AppBaseConfigContext.Provider>
    )
}

export const useBaseConfigContext = (): AppBaseConfig => {
    const context = React.useContext(AppBaseConfigContext)
    if (context === undefined) {
        throw new Error('useBaseConfigContext must be used within an AppBaseConfigProvider')
    }
    const deployment = useTenantlessDeploymentContext();
    return context.getConfig(deployment.environment, deployment.instance);
}

export default AppBaseConfigProvider

